// extracted by mini-css-extract-plugin
module.exports = {"NewsOverview":"NewsOverview__2S5BO","NewsOverview_card":"NewsOverview_card__2S5BO","NewsOverview_pagination":"NewsOverview_pagination__2S5BO"};